export const API_URL = process.env.REACT_APP_API_URL as string;
export const BASE_URL = process.env.REACT_APP_BASE_URL as string;
